import { FC } from "react";

import { Chip, useTheme } from "@mui/material";

import { useMenu } from "components/Menu/context";
import { getPageLanguage } from "utils/language";

import { accountMenuStyles } from "../../AccountMenu.styles";
import { useAccountMenuTranslation } from "../../i18n";

export const NewMenuItemChip: FC = () => {
  const theme = useTheme();
  const { languageNodes } = useMenu();
  const { translate } = useAccountMenuTranslation(
    getPageLanguage(languageNodes)
  );

  return (
    <Chip
      component="span"
      css={accountMenuStyles.newMenuItemChip(theme)}
      size="small"
      label={translate("new")}
    />
  );
};
